module.exports = __webpack_public_path__ + "img/award_bronze.6ce9ece3.svg";